import React from "react";
import { ChevronDown, ChevronUp, ChevronRight } from "lucide-react";
import styles from "./BotonModern.module.scss";

interface NavButton {
  id: string;
  nombre: string;
  icono: React.ReactNode;
  color: string;
  route: string;
  badge?: number;
  adminOnly?: boolean;
  hasSubmenu?: boolean;
  subItems?: NavSubItem[];
}

interface NavSubItem {
  id: string;
  label: string;
  icon: React.ReactNode;
  route: string;
  directRoute?: string;
}

interface BotonModernProps {
  button: NavButton;
  isActive: boolean;
  onClick: () => void;
  hasSubmenu?: boolean;
  isSubmenuExpanded?: boolean;
  chevronRight?: boolean;
  hideIcon?: boolean;
}

const BotonModern: React.FC<BotonModernProps> = ({ button, isActive, onClick, hasSubmenu, isSubmenuExpanded, chevronRight, hideIcon }) => {
  return (
    <button
      className={`${styles.boton} ${isActive ? styles.active : ''} ${hideIcon ? styles.botonNoIcon : ''}`}
      onClick={onClick}
      style={{ '--button-color': button.color } as React.CSSProperties}
    >
      {!hideIcon && (
        <div className={styles.iconContainer}>
          <div className={styles.icon}>
            {button.icono}
          </div>
          {button.badge && button.badge > 0 && (
            <span className={styles.badge}>
              {button.badge > 99 ? '99+' : button.badge}
            </span>
          )}
        </div>
      )}

      <span className={styles.label}>{button.nombre}</span>
      {hideIcon && button.badge && button.badge > 0 && (
        <span className={styles.badgeInline}>
          {button.badge > 99 ? '99+' : button.badge}
        </span>
      )}

      {hasSubmenu && (
        <div className={styles.submenuArrow}>
          {chevronRight ? <ChevronRight size={18} /> : (isSubmenuExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />)}
        </div>
      )}
      
      {isActive && (
        <div className={styles.activeIndicator} />
      )}
    </button>
  );
};

export default BotonModern;
